module.exports = __webpack_public_path__ + "media/images/flags/np-ea81b6ddb546b4b6cba1e01b509a9518.svg";